import { type CSSObject } from '@emotion/react';
import { useTheme } from '@doxyme/ui/theme';

type UseStylesReturnType = Record<
  'container' | 'wrapper' | 'button' | 'icon',
  CSSObject
>;

export const useSendFromMyEmailTabStyles = (): UseStylesReturnType => {
  const theme = useTheme();

  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(4),
      alignSelf: 'stretch',
    },
    wrapper: {
      display: 'flex',
      alignItems: 'stretch',
      gap: theme.spacing(4),
      alignSelf: 'stretch',
    },
    button: {
      height: 56,
      padding: theme.spacing(2, 3),
      alignSelf: 'stretch',
      cursor: 'pointer',
    },
    icon: {
      height: 44,
    },
  };
};
